import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import Swiper from 'swiper'

class News extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      slider: null
      //trigger: null,
    
    }

  }

  mount() {

    //  this.slider = new Glide('.glide', {
    //      gap: 0
    //  }).mount()
    
    // this.flkty = new Flickity(this.ref.slider, {
    //     // options
    //     cellAlign: 'left',
    //     contain: true,
    //     wrapAround: true,
    //     //prevNextButtons: false, 
    //     //pageDots: false

    // });

     this.swiper = new Swiper(this.ref.slider, {
       slidesPerView: 1,
     //  loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
       pagination: {
         el: ".swiper-pagination",
         clickable: true
       }
     });



      
}



resize(){
  
}

  unmount() {

this.swiper.destroy()


  }


}

module.exports = News
